import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { AnatomicalSideLabelPipe, BaseLldTableComponent, HighlightCellDirective } from '../../shared';


/**
* Table of Limb Length Discrepancy in deformity analysis.
*/
@Component({
	selector: 'lld-table',
	templateUrl: './lld-table.component.html',
	imports: [
		NgbCollapseModule,
		HighlightCellDirective,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LldTableComponent extends BaseLldTableComponent {

	isCollapsed = true;

}
